import { renderImageBlock } from '../render/blocks/image';
import { ImageBlockSettings } from '../settings/blocks/image';
import { defineBlockRegistryEntry } from './defineEntry';
import { imageBlockDefinition } from '../domain/blocks/image';

export const imageBlockRegistryEntry = defineBlockRegistryEntry(
  imageBlockDefinition,
  renderImageBlock,
  ImageBlockSettings,
);
